import { API } from '../../http';

async function getAll({ page }) {
  return await API.get(`/hielocos?page=${page}`);
}
async function get(id) {
  return await API.get(`/hieloco/${id}`);
}

async function search(searchValue) {
  return await API.get(`/hielocos/${searchValue}`);
}

async function createHieloco(hieloco) {
  const { name, image_url, id } = hieloco;
  const formData = new FormData();

  formData.append('name', name);
  formData.append('image_url', image_url);
  formData.append('ref', id);

  return await API.post('/hielocos', formData, {
    headers: { enctype: 'multipart/form-data' },
  });
}

async function createLocalHieloco(hieloco) {
  const { name, picture } = hieloco;
  const formData = new FormData();

  formData.append('name', name);
  formData.append('picture', picture);

  return await API.post('/hielocos/local', formData, {
    headers: { enctype: 'multipart/form-data' },
  });
}

async function updateHieloco(hieloco) {
  const { id } = hieloco;
  const formData = new FormData();
  return await API.put(`/hieloco/${id}`, formData, {
    headers: { enctype: 'multipart/form-data' },
  });
}

async function deleteHieloco(id) {
  return await API.delete(`/hieloco/${id}`);
}

const hielocosServices = {
  getAll,
  get,
  search,
  createHieloco,
  createLocalHieloco,
  updateHieloco,
  deleteHieloco,
};

export default hielocosServices;
